export const LP_ERROR_KEYS = {
  LICENSE_PLATE: 'licensePlate',
  LICENSE_PLATE_WIDE: 'licensePlateWide',
  STATE_CODE: 'stateCode',
};

export const LICENSE_PLATE_MAX_LENGTH = 9;
